/* eslint no-param-reassign: ["error", { "props": false }] */
function parse(value, fallback) {
  if (typeof value === 'undefined') {
    return fallback;
  }
  switch (typeof fallback) {
    case 'boolean':
      return !!JSON.parse(value);
    case 'number':
      return JSON.parse(value);
    default:
      return value;
  }
}

const config = {
  maxIdleTime: parse(process.env.VUE_APP_USER_SESSION_EXPIRE_IN, 20),
  userSessionWarningStartsIn: parse(process.env.VUE_APP_USER_SESSION_WARNING_STARTS_IN, 15),
  outageWarningStartsIn: parse(process.env.VUE_APP_OUTAGE_WARNING_STARTS_IN, 20),
  tokenRefresgRequiredBefore: parse(process.env.VUE_APP_TOKEN_REFRESH_REQUIRED_BEFORE, 2),
  authApiRootUrl: parse(process.env.VUE_APP_AUTH_API_ROOT, 'http://localhost:3030/auth'),
  eServApiRootUrl: parse(process.env.VUE_APP_ESERV_API_ROOT, 'http://localhost:3300/api'),
  tmsApiRootUrl: parse(process.env.VUE_APP_TMS_API_ROOT, 'http://localhost:3310/api'),
  paymentApiRootUrl: parse(process.env.VUE_APP_PAYMENT_API_ROOT, 'http://localhost:39933/api'),
  melissaRootUrl: parse(process.env.VUE_MELISSA_API_ROOT, 'https://expressentry.melissadata.net/jsonp'),
  melissaApiFormat: parse(process.env.MELISSA_API_FORMAT, 'json'),
  melissaApiLicenseKey: parse(process.env.MELISSA_API_LICENSE_KEY, 'piEFmal0Xp65XNBcjs8ins**'),
  melissaApiMaxRecord: parse(process.env.MELISSA_API_MAXRECORDS, 15),
  melissaApiMinLength: parse(process.env.MELISSA_API_MINLENGTH, 2),
  googleReCaptchaSiteKey: parse(process.env.VUE_APP_CAPTCHA_SITE_KEY, '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'), // by default testing site key
  passwordValidationMessage: '** Password should have at least 12 characters, one uppercase letter, one lowercase letter, and one number',
  env: parse(process.env.VUE_APP_ENV, 'DEV'),
  frequencyToCheckServerForUpdates: parse(60 * 4, 60 * 4), // 4 hours
  outageBackdoorCode: parse(process.env.OUTAGE_BACKDOOR_CODE, "super-admin"),
  // eBizApiRootUrl: parse(process.env.VUE_APP_EBIZ_API_ROOT, 'http://localhost:3330/api'),
  // ovsApiRootUrl: parse(process.env.VUE_APP_OVS_API_ROOT, 'http://localhost:3340/api'),
  // ccApiRootUrl: parse(process.env.VUE_APP_CC_API_ROOT, 'http://localhost:3350/api'),

//   features: {
//     example: parse(process.env.VUE_APP_FEATURE_EXAMPLE, false),
//     ...
//   },
};

// function feature(name) {
//   return config.features[name];
// }

export default config;

const generateKey = (length) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charLength = characters.length;

  for (let i = 0; i < length; i += 1) {
    const randomIndex = Math.floor(Math.random() * charLength);
    const selected = characters[randomIndex];
    result += selected;
  }
  return result;
};

export const APP_DATA = {
  idleTime: 0,
  appKey: generateKey(12),

};
